<template>
  <ProSpaceRightPanel
    :header="header"
    :has-error="hasError"
    :loading="loading"
    @edit="editPanel"
    @delete="deletePanel"
    @clear="clearPanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="selectedCount === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerRoles">
        <template #header>
          <ProSpaceAction :text="$t('editItemTxt')" @click="onClickEdit" />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="selectedCount === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
    <template v-if="isMultipleView()" v-slot:center>
      <ProSpaceVLayout :gap="30">
        <ProSpacePanelBlock v-if="isAllRowsSelected" class="prospace-panel-block--empty" :header="{title: $t('itemsSelectedAll')}">
          <template #header>
            <ProSpaceAction
              :text="$t('clearTxt')"
              @click="clearPanelAll"
            />
          </template>
        </ProSpacePanelBlock>
        <PanelBlockSelectedItems :items="[
            { name: $t('id'), value: 'id', f: (v) => v },
            { name: $t('name'), value: 'displayName', f: (v) => v },
          ]"
        />
      </ProSpaceVLayout>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
  ProSpacePanelBlockHeader,
  ProSpaceSimpleGrid,
  ProSpaceModal,
  ProSpaceVLayout
} from "@prospace/prospace-components-library";
import { mapGetters } from "vuex";
import { getAMorPM } from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
import {
  useMultiSelectRightPanel,
} from "@composes/multiselect"
import PanelBlockSelectedItems from "@multiselect/PanelBlockSelectedItems"
export default {
  name: "RolePanel",
  components: {
    ProSpaceRightPanel,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
    ProSpacePanelBlockHeader,
    ProSpaceSimpleGrid,
    ProSpaceModal,
    PanelBlockSelectedItems,
    ProSpaceVLayout
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    service: {
      type: Object,
      required: true,
    },
    model: {
      type: Array,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    clude: {
      type: Object,
      required: false,
    },
    isAllRowsSelected: {
      type: Boolean,
      default: false
    },
  },
  setup() {
    const { selectedData, selectedClude, selectedCount, isMultipleView } = useMultiSelectRightPanel()
    return {
      selectedData, selectedClude, selectedCount, isMultipleView
    }
  },
  data() {
    return {
      role: null,
      header: {},
      loading: false,
      hasError: false,
      modelModalClude: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerRoles() {
      return {
        title: this.$t("role"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    header() {
      if (this.role) {
        return {
          title: this.role.systemName,
          id: this.role.id,
          status: this.getStatus(this.role.status),
          options: this.options,
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.selectedCount,
        showCounter: true,
      };
    },
    content() {
      if (this.role) {
        return [
          [
            {
              title: this.$t("name"),
              text: this.role.systemName,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.role) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.role.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.role.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text:
                this.getFormatDateTime(this.role.createdAt) +
                " " +
                getAMorPM(this.role.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text:
                this.getFormatDateTime(this.role.lastUpdated) +
                " " +
                getAMorPM(this.role.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    selectedData() {
      this.update();
    },
    selectedCount() {
      this.update()
    },
  },
  methods: {
    editPanel() {
      this.$emit("edit", this.role);
    },
    deletePanel() {
      this.$emit("delete-item", this.role);
    },
    clearPanel() {
      if (!this.isAllRowsSelected && (this.count === this.clude.items?.length)) {
        this.$emit("clear");
      } else if (this.isAllRowsSelected && (this.count > this.clude.items?.length) && this.clude.isAll) {
        this.$emit("clear:excluded");
      } else {
        this.$emit("clear");
      }
    },
    clearPanelAll() {
      this.$emit("clear");
    },
    showHistoryPanel() {
      this.$emit("history-item", this.role);
    },
    async update() {
      this.hasError = false;
      try {
        this.role = await this.getRole();
      } catch (e) {
        this.hasError = true;
      }
    },
    async getRole() {
      if (this.selectedCount === 1) {
        this.loading = true;
        const res = await this.service.get(this.selectedData.id);
        this.loading = false;
        return res.data;
      }
      return null;
    },
    getStatus(status) {
      return {
        type: status
          ? status.toLowerCase() === "active"
            ? "success"
            : "danger"
          : "no-data",
        text: status
          ? status[0].toUpperCase() + status.toLowerCase().slice(1)
          : "No data",
      };
    },
    onClickEdit() {
      this.$emit("edit", this.role);
    },
  },
};
</script>
